import React from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Wrap from '../containers/scenes/Wrap'
import WechatPayConfirmation from '../containers/scenes/WechatPayConfirmation'

const preventDefaultCallback = (event) => event.preventDefault()
const RouterModule = (props) => {
  if (props.isSwitchOnRightSideBar || props.isSwitchBottomSheet) {
    document.body.addEventListener('touchmove', preventDefaultCallback, { passive: false })
    document.body.style.overflow = 'hidden'
  } else {
    document.body.removeEventListener('touchmove', preventDefaultCallback)
    document.body.style.overflow = 'auto'
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            return (
              <Redirect to={{ pathname: '/home', search: window.location.search }}/>
            )
          }}
        />
        <Route
          exact
          path='/home'
          component={Wrap}
        />
        <Route
          path='/category'
          component={Wrap}
        />
        <Route
          path='/tag'
          component={Wrap}
        />
        <Route
          path='/basket'
          component={Wrap}
        />
        <Route
          path='/wechatpay_confirmation'
          component={WechatPayConfirmation}
        />
        <Route
          render={() => <p>404, Page Not Found</p>}
        />
      </Switch>
    </BrowserRouter>
  )
}
const mapStateToProps = (state) => {
  return {
    isSwitchOnRightSideBar: state.isSwitchOnRightSideBar,
    isSwitchBottomSheet: state.isSwitchBottomSheet,
    isNavBarSwiperExpanded: state.isNavBarSwiperExpanded,
  }
}

/**
 * Export
 */
export default connect(mapStateToProps)(RouterModule)



// WEBPACK FOOTER //
// ./src/routers/index.js